export default __webpack_public_path__ + "static/inline-usage-example-43b22c2a16cab8066ee37e64581a5be1f71ac2d27309c3d3c385bcf1aae19a5c.png";